"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _Hint = _interopRequireDefault(require("./Hint.react"));

var _Input = _interopRequireDefault(require("./Input.react"));

var _withClassNames = _interopRequireDefault(require("../containers/withClassNames"));

var _default = (0, _withClassNames["default"])(function (_ref) {
  var inputRef = _ref.inputRef,
      referenceElementRef = _ref.referenceElementRef,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["inputRef", "referenceElementRef"]);
  return /*#__PURE__*/_react["default"].createElement(_Hint["default"], null, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, props, {
    ref: function ref(node) {
      inputRef(node);
      referenceElementRef(node);
    }
  })));
});

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/components/TypeaheadInputSingle.react.js
// module id = 278
// module chunks = 0